/***
*
*   HOMEPAGE
*   Homepage template with features, testimonials and CTA
*
**********/

import React, { Fragment } from 'react';
import { Hero } from 'components/lib';
import { OurCustomers } from './OurCustomers';

export function Home(props) {

  return (
    <Fragment>

      <Hero
        title='AIVAGAM'
        tagline='Gain 3 Years of Full Stack Development Experience in 4 Weeks'
      // image={ ImgDashboard }
      />

      <OurCustomers />
    </Fragment>
  );
}
